import RetailerOrdersList from './RetailerOrdersList'

export default RetailerOrdersList
